import * as React from 'react'
import { Icon, Menu, Responsive, Segment, Sidebar, Visibility } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { MenuReponsive } from '../components'

type DesktopContainerProps = {
  isLoggedIn: boolean,
  userInfo?: IUser,
  handleSignIn: (event: React.MouseEvent<any>) => void,
  handleSignOut: (event: React.MouseEvent<any>) => void,
  handleRegister: (event: React.MouseEvent<any>) => void,
}

class DesktopContainer extends React.Component<DesktopContainerProps> {
  state = {
    fixed: false
  }

  hideFixedMenu = () => this.setState({fixed: false})
  showFixedMenu = () => this.setState({fixed: false})

  render() {
    const {fixed} = this.state
    const {handleSignIn, handleRegister, handleSignOut, isLoggedIn, children, userInfo} = this.props
    return (
      <Responsive minWidth={Responsive.onlyMobile.maxWidth}>
        <Visibility once={false} onBottomPassed={this.showFixedMenu} onBottomPassedReverse={this.hideFixedMenu}>
          <MenuReponsive
            fixed={fixed}
            isLoggedIn={isLoggedIn}
            handleSignIn={handleSignIn}
            handleSignOut={handleSignOut}
            handleRegister={handleRegister}
            userInfo={userInfo}
          />

        </Visibility>
        {children}
      </Responsive>
    )
  }
}

type MobileContainerProps = {
  isLoggedIn: boolean,
  userInfo?: IUser,
  handleSignIn: (event: React.MouseEvent<any>) => void,
  handleSignOut: (event: React.MouseEvent<any>) => void,
  handleRegister: (event: React.MouseEvent<any>) => void,
}

class MobileContainer extends React.Component<MobileContainerProps> {
  state = {
    sidebarOpened: false
  }

  handlePusherClick = () => {
    const {sidebarOpened} = this.state

    if (sidebarOpened) { this.setState({sidebarOpened: false}) }
  }

  handleToggle = () => this.setState({sidebarOpened: !this.state.sidebarOpened})

  render() {
    const {sidebarOpened} = this.state
    const {isLoggedIn, handleRegister, handleSignIn, handleSignOut, children, userInfo} = this.props
    return (
      <Responsive maxWidth={Responsive.onlyMobile.maxWidth}>
        <Sidebar.Pushable>
          <Sidebar as={Menu} animation="slide out" inverted={true} vertical={true} visible={sidebarOpened}>
            <MenuReponsive
              isLoggedIn={isLoggedIn}
              handleSignIn={handleSignIn}
              handleSignOut={handleSignOut}
              handleRegister={handleRegister}
              userInfo={userInfo}
            />
          </Sidebar>

          <Sidebar.Pusher
            dimmed={sidebarOpened}
            onClick={this.handlePusherClick}
            style={{minHeight: '100vh'}}
          >
            <Segment inverted={true} textAlign="center" style={{padding: '1em 0em'}} vertical={true}>
                <Menu inverted={true} pointing={true} secondary={true} size="large">
                  <Menu.Item onClick={this.handleToggle}>
                    <Icon name="content"/>
                  </Menu.Item>
                  <Menu.Item as="a" href={'/pick'} active={true}>EZValue</Menu.Item>
                </Menu>
            </Segment>
            {children}
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </Responsive>
    )
  }
}

type HeaderProps = {
  isLoggedIn: boolean,
  userInfo?: IUser,
  cartInfo: IOrderInfo,
  handleSignIn: (event: React.MouseEvent<any>) => void
  handleSignOut: (event: React.MouseEvent<any>) => void
  handleRegister: (event: React.MouseEvent<any>) => void
  children: React.ReactNode
}

class ResponsiveHeader extends React.Component<HeaderProps> {
  render() {
    const {isLoggedIn, userInfo, handleSignIn, handleSignOut, handleRegister, children } = this.props
    return (
      <div>
        <DesktopContainer
          isLoggedIn={isLoggedIn}
          userInfo={userInfo}
          handleSignIn={handleSignIn}
          handleSignOut={handleSignOut}
          handleRegister={handleRegister}
          children={children}
        />
        <MobileContainer
          isLoggedIn={isLoggedIn}
          userInfo={userInfo}
          handleSignIn={handleSignIn}
          handleSignOut={handleSignOut}
          handleRegister={handleRegister}
          children={children}
        />
      </div>
    )
  }
}

const mapStateToProps = (state: IAppState, ownProps: any) => ({
  ...ownProps,
  isLoggedIn: state.loggedIn,
  userInfo: state.root.userInfo
})

export default connect(mapStateToProps)(ResponsiveHeader)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/containers/ResponsiveHeader.tsx